export enum RoleEnum {
  SUPER_ADMIN = "super_admin",
  /**
   * can access all courses, grades and subjects
   * can access parents and users
   */
  ADMIN = "admin",
  /**
   * Near–full CP access; education content scoped to assigned education systems.
   * Cannot manage Education System module or critical ops modules.
   */
  SYSTEM_ADMIN = "system_admin",
  /**
   * can access courses, grades and subjects under assigned education systems
   */
  HEAD_TEACHER_ADMIN = "head_teacher_admin",
  /**
   * can access assigned courses, grades and subjects
   */
  TEACHER_ADMIN = "teacher_admin",
  STUDENT = "student",
  TEACHER = "teacher",
  PARENT = "parent",
  VIRTUAL = "virtual",
}

export enum NotificationAudienceEnum {
  STUDENT = "student",
  PARENT = "parent",
  TEACHER = "teacher",
  GRADE = "grade",
  USER = "user",
  TEACHER_ADMIN = "teacher_admin",
  SYSTEM_ADMIN = "system_admin",
  HEAD_TEACHER_ADMIN = "head_teacher_admin",
  PARENT_NO_PURCHASE = "parent_no_purchase",
  STUDENT_NO_PURCHASE = "student_no_purchase",
}
